import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import FormDialog from "src/components/common/FormDialog";
import MerchantPicker from "src/components/common/MerchantPicker";
import UserPicker from "src/components/common/UserPicker";
import FormItem from "src/components/form-item/FormItem";
import { alert } from "src/services/alert";
import { asyncRequest } from "src/services/network";

const SpeakerAddDialog = ({ item, open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    mid: item.mid || "",
    sn: item.sn || "",
  });

  const [merchant, setMerchant] = useState(item.mer || {});
  const [user, setUser] = useState({});

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    // if (!user.uid) return alert("请选择用户");
    if (!merchant.mid) return alert("请选择商户");

    const formData = {
      ...form,
      mid: merchant.mid,
    }

    if (item.id) {
      formData.id = item.id;
    }

    const { msg } = await asyncRequest({
      path: item.id ? "/merchant/speaker/edit" : "/merchant/speaker/add",
      data: formData,
    });

    alert(msg, "success");
    onUpdate();
  }

  function handleSelectMerchant() {
    MerchantPicker({
      onSelect(val) {
        console.log(val);
        setMerchant(val);

        setForm({
          ...form,
          mid: val.mid,
        })
      },
    });
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        console.log(val);
        setUser(val);
      },
    });
  }

  return (
    <FormDialog title={item.id ? '编辑播报器' : "添加播报器"} open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="商户" required sx={{ width: 500 }}>
        <TextField fullWidth placeholder="请选择商户" autoComplete="off" id="merchant" value={merchant.name || ""} size="small" onClick={() => handleSelectMerchant()} />
      </FormItem>

      <FormItem title="编号" required>
        <TextField fullWidth placeholder="编号" autoComplete="off" id="sn" value={form.sn} size="small" onChange={(e) => handleIptChange("sn", e.target.value)} />
      </FormItem>
    </FormDialog>
  );
};

export default SpeakerAddDialog;
